import { render } from "./ActivityList.vue?vue&type=template&id=2162a6b6&ts=true"
import script from "./ActivityList.vue?vue&type=script&lang=ts"
export * from "./ActivityList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__